import unescape from 'helpers/unescape';

angular
  .module('memberPortal')
  .factory('DataService', function () {
    return {
      ...window.DATA,
      gym_name: unescape(window.DATA.gym_name),
      gym_email: unescape(window.DATA.gym_email),
      gym_phone_number: unescape(window.DATA.gym_phone_number)
    };
  });
